/**
 * @group Action
 * @summary <blockquote>Log message templates for server actions.</blockquote>
 */
export const ACTION_LOG_MESSAGES = {
  ERROR_DURING_OPERATION: 'Action error during',
  OPERATION_COMPLETED: 'Action completed successfully for',
  OPERATION_STARTED: 'Action started for',
} as const; 